import React, { ReactNode } from "react";
import Tagline from "../../../assets/customization/Tagline";
import SideBySideImg from "../../../assets/customization/side_by_side.png";
import LandscapeBanner from "../../../assets/customization/landscape_banner.png";
import SplitBanner from "../../../assets/customization/split_banner.png";
import Values from "../../../assets/customization/values.png";

interface TabContainerHOCProps {
  title?: string;
  description?: ReactNode;
  containerClass?: string;
  loading?: boolean;
  children: ReactNode;
  commingSoon?: boolean;
}

const TabContainerHOC: React.FC<TabContainerHOCProps> = ({
  title,
  description,
  containerClass,
  loading,
  children,
  commingSoon = false,
}) => {
  const isSpecialLayout = title === 'Tagline' || title === 'Side By Side' || title === 'Landscape Banner' || title === 'Split Banner' || title === 'Values - Why Choose Us';

  const renderImage = () => {
    if (title === 'Tagline') return <Tagline />;
    if (title === 'Side By Side') return <img src={SideBySideImg} alt="Side by Side Preview" className="side-by-side-preview-img" />;
    if (title === 'Landscape Banner') return <img src={LandscapeBanner} alt="Landscape Banner Preview" className="landscape-banner-preview-img" />;
    if (title === 'Split Banner') return <img src={SplitBanner} alt="Landscape Banner Preview" className="split-banner-preview-img" />;
    if (title === 'Values - Why Choose Us') return <img src={Values} alt="Values Preview" className="values-preview-img" />;
    return null;
  };

  return (
    <div className={`container ${containerClass}`}>
      <div className="topBar" />

      <div className={`wrapperContent ${commingSoon ? 'coming-soon' : ''}`}>
        {isSpecialLayout ? (
          <div className="special-description">
            <div>
              <div className="titleHeader">
                <h1>{title}</h1>
              </div>
              {description}
            </div>
            {renderImage()}
          </div>
        ) : (
          <>
            <div className="titleHeader">
              <h1>{title}</h1>
            </div>

            {description && (
              <div className="mt-3 generic-description">{description}</div>
            )}
          </>
        )}

        {loading ? (
          <div className="loader-container">
            <div className="loader">
              {Array.from({ length: 50 }).map((_, idx) => (
                <div key={idx} className="dot" />
              ))}
            </div>
          </div>
        ) : (
          <>
            {commingSoon && (
              <div className="disabled-overlay">
                <div className="coming-soon-message">
                  <h1>Coming Soon</h1>
                  <p>
                    A new update is just around the corner. Coming soon to enhance your experience.
                  </p>
                </div>
              </div>
            )}
            {children}
          </>
        )}
      </div>
    </div>
  );

};

export default TabContainerHOC;